<script setup lang="ts" generic="T">
import { ref, provide, onMounted, Ref } from "vue";

import { ValidationErrors, extractValidationErrors } from "@vm/validation";

import { ValidationProvider } from "@vm/validation/components";

import {
  formDataKey,
  validationErrorsKey,
  resetValidationErrorsKey,
  type ErrorCallback,
} from "../form";

const { formData, onSubmit, onError, onSuccess } = defineProps<{
  formData: T;
  onSubmit: (data: T) => unknown | Promise<unknown>;
  onError?: ErrorCallback;
  onSuccess?: () => void;
}>();

const validationErrors = ref<ValidationErrors>();
const formDataRef = ref(formData) as Ref<T>;

async function handleSubmit() {
  try {
    await onSubmit?.(formDataRef.value);
    onSuccess?.();
  } catch (error) {
    console.error(error);
    validationErrors.value = extractValidationErrors(error);
    if (validationErrors.value) {
      return onError?.(validationErrors.value, true);
    }
    console.error(error);
    // TODO: improve frontend error handling
    window.alert("Er is iets misgegaan bij het opslaan");
    onError?.(error, false);
  }
}

function resetValidationErrors() {
  validationErrors.value = {};
}

provide(formDataKey, formDataRef);
provide(validationErrorsKey, validationErrors);
provide(resetValidationErrorsKey, resetValidationErrors);

onMounted(() => {
  resetValidationErrors();
});
</script>

<template>
  <ValidationProvider :validation-errors="validationErrors">
    <form @submit.prevent="handleSubmit"><slot /></form>
  </ValidationProvider>
</template>
